import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { UIModule } from '@app-domains/ui/ui.module'
import { TranslateRouterModule } from '@endeavour/ngx-translate-router'
import { TranslateModule } from '@ngx-translate/core'
import { ContentBlocksModule } from '@app-domains/content-blocks/content-blocks.module'
import { DealersComponent } from './dealers.component'
import { GoogleMapsComponentModule } from '@app-domains/google-maps/google-maps.module'
import { DirectivesModule } from '@app-directives/directives.module'
import { TransformDealerPipe } from './pipes/transform-dealer/transform-dealer.pipe'
import { AlgoliaModule } from '@app-domains/algolia/algolia.module'
import { ProductListDomainModule } from '@app-domains/product-list/product-list-domain.module'
import { DealersHitsComponent } from './components/dealers-hits/dealers-hits.component'
import { PipesModule } from '@app-pipes/pipes.module'

const routes = [
    {
        path: '',
        component: DealersComponent,
    },
]

@NgModule({
    declarations: [
        DealersComponent,
        TransformDealerPipe,
        DealersHitsComponent,
    ],
    imports: [
        CommonModule,
        UIModule,
        RouterModule.forChild(routes),
        TranslateRouterModule.forChild(routes),
        TranslateModule,
        ContentBlocksModule,
        GoogleMapsComponentModule,
        DirectivesModule,
        AlgoliaModule,
        ProductListDomainModule,
        PipesModule,
    ],
})
export class DealersModule {
}
